"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportType = exports.isMobile = exports.defaultStreamUrl = exports.pages = exports.paginationVariables = exports.OUTRIGHTS_LIMIT_PER_PAGE = exports.MATCHES_LIMIT_PER_PAGE = exports.springConfig = exports.idPathDivider = exports.ROUTE_DIVIDER = void 0;
var types_1 = require("./types");
var checkMobile_1 = __importDefault(require("./utils/checkMobile"));
exports.ROUTE_DIVIDER = '/';
exports.idPathDivider = '~';
exports.springConfig = {
    stiffness: 150,
    damping: 20,
    precision: 0.1,
};
// TODO: remove MATCHES_LIMIT_PER_PAGE, OUTRIGHTS_LIMIT_PER_PAGE
exports.MATCHES_LIMIT_PER_PAGE = 20;
exports.OUTRIGHTS_LIMIT_PER_PAGE = 50;
// TODO: remove paginationVariables, hardcode
exports.paginationVariables = {
    offset: 0,
    limit: exports.MATCHES_LIMIT_PER_PAGE,
};
exports.pages = {
    upcoming: [
        types_1.App.Routes.UPCOMING_LIST,
        types_1.App.Routes.MATCH,
        types_1.App.Routes.TOURNAMENT,
    ],
    live: [types_1.App.Routes.LIVE_LIST],
    outright: [types_1.App.Routes.OUTRIGHTS_LIST, types_1.App.Routes.OUTRIGHT],
    result: [types_1.App.Routes.RESULTS_LIST, types_1.App.Routes.RESULT_MATCH],
    prematch: [
        types_1.App.Routes.PREMATCH,
        types_1.App.Routes.ESPORT,
        types_1.App.Routes.CLASSIC,
        "" + types_1.App.Routes.ESPORT + types_1.App.Routes.PREMATCH,
        "" + types_1.App.Routes.CLASSIC + types_1.App.Routes.PREMATCH,
    ],
};
exports.defaultStreamUrl = 'about:blank';
exports.isMobile = checkMobile_1.default();
var SportType;
(function (SportType) {
    SportType["Mix"] = "mix";
    SportType["Esport"] = "esport";
    SportType["Classic"] = "classic";
})(SportType = exports.SportType || (exports.SportType = {}));
//# sourceMappingURL=constants.js.map